var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('svg',{staticClass:"circle-loader progress",attrs:{"width":_vm.size,"height":_vm.size,"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":_vm.radius}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }